import type { ReactNode } from 'react';
import { Fragment } from 'react';

import { ListingTypeLabel } from '#/modules/listing/components/ListingTypeLabel/ListingTypeLabel';
import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';
import {
  SearchHitInfoFooterHolder,
  SearchHitInfoHeader,
  SearchHitInfoHeaderHeading,
  SearchHitInfoHeaderOrgName,
  SearchHitInfoHolder,
  SearchHitInfoPipe,
  SearchHitInfoStats,
} from '#/modules/search/components/Hit/Info/SearchHitInfo.styled';
import {
  safeUtf8StringSlice,
  utf8StringLength,
} from '#/utils/string/safeUtf8String';

import { SearchHitInfoBoxListingLabelsPill } from './SearchGroupHitInfo.styled';

type Props = {
  hiring: boolean;
  listingStats: ReactNode[];
  orgStat?: ReactNode;
  name: string;
  orgType: string | null;
  showLabel: boolean;
  pillItems: string[];
};

export function SearchGroupHitInfo({
  hiring,
  listingStats,
  orgStat,
  name,
  orgType,
  showLabel,
  pillItems,
}: Props) {
  return (
    <SearchHitInfoHolder>
      {showLabel && (
        <div style={{ marginBottom: 14 }}>
          <ListingTypeLabel listingType="ORG" orgType={ApiOrgType.GROUP} />
        </div>
      )}

      <SearchHitInfoHeader>
        <SearchHitInfoHeaderHeading>
          <div>
            <span data-qa-id="search-result-link">
              {safeUtf8StringSlice(name, 0, 120)}
            </span>
            {utf8StringLength(name) > 120 && <>&hellip;</>}
          </div>
        </SearchHitInfoHeaderHeading>

        {orgType === 'CORPORATION' && (
          <SearchHitInfoHeaderOrgName>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              {name}
            </div>
          </SearchHitInfoHeaderOrgName>
        )}
      </SearchHitInfoHeader>

      {pillItems.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          {pillItems.map((pillItem) => (
            <SearchHitInfoBoxListingLabelsPill key={pillItem}>
              {pillItem}
            </SearchHitInfoBoxListingLabelsPill>
          ))}
        </div>
      )}

      <SearchHitInfoFooterHolder>
        {listingStats.length > 0 && (
          <SearchHitInfoStats>
            {listingStats.map((info, index) => (
              <Fragment key={index}>
                {((index > 0 && !hiring) || (index > 1 && hiring)) && (
                  <SearchHitInfoPipe />
                )}
                {info}
              </Fragment>
            ))}
          </SearchHitInfoStats>
        )}
        {orgStat}
      </SearchHitInfoFooterHolder>
    </SearchHitInfoHolder>
  );
}
